module.exports = __webpack_public_path__ + "static/qing.dd10266a.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/qing.jpeg
// module id = 171
// module chunks = 0